import { useEffect, useRef } from 'react';

const AudioFeedback = ({ 
  isRecording, 
  transcript, 
  error, 
  success 
}) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!audioRef.current) return;

    // Создаем звуковые уведомления
    const playSound = (frequency, duration, type = 'sine') => {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
      oscillator.type = type;
      
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + duration);
    };

    // Звуки для разных событий
    if (isRecording) {
      // Звук начала записи - восходящий тон
      playSound(440, 0.2);
    }
    
    if (transcript && !isRecording) {
      // Звук завершения записи - нисходящий тон
      playSound(330, 0.3);
    }
    
    if (error) {
      // Звук ошибки - низкий тон
      playSound(220, 0.5, 'sawtooth');
    }
    
    if (success) {
      // Звук успеха - высокий тон
      playSound(660, 0.2);
    }

  }, [isRecording, transcript, error, success]);

  return null; // Компонент не рендерит ничего визуального
};

export default AudioFeedback;
